import React, {Suspense} from 'react';
import {InputText} from 'primereact/inputtext';
import {TabPanel, TabView} from 'primereact/tabview';
import {InputNumber} from 'primereact/inputnumber';
import {ComponentTypeWithID, getDashboardComponentTypes} from "../ComponentType";
import {Dropdown} from 'primereact/dropdown';
import Editor from "@monaco-editor/react";
import {ProgressSpinner} from "primereact/progressspinner";
import {isJSON} from "../../utils/utils";

import 'style/overrides.scss'
import { easasAlert } from './easas-global-fragment/EasasGlobalAlerts';


type ConfigurationModel = {
    title: string;
    width: number | null;
    componentType: string | undefined;
    jsonConfig: string | undefined;
}

type ConfiguratorProps = {
    widgetVar: string,
    model: ConfigurationModel;
};

type ConfigurationState = ConfigurationModel;

class DashboardComponentConfigurator extends React.Component<ConfiguratorProps, ConfigurationState> {
    private readonly componentTypes: ComponentTypeWithID[];
    private readonly jsonInputEl: HTMLInputElement | null;

    constructor(props: ConfiguratorProps) {
        super(props);

        this.jsonInputEl = document.getElementById(PF(props.widgetVar).id) as HTMLInputElement;
        this.componentTypes = getDashboardComponentTypes();
        this.onJSONChange = this.onJSONChange.bind(this);

        this.state = {
            title: props.model.title,
            width: props.model.width,
            componentType: props.model.componentType,
            jsonConfig: props.model.jsonConfig
        }
        }

        onJSONChange(json:object) {
            this.setState(prevState => ({...prevState, jsonConfig:JSON.stringify(json)}));
    }
       get currentComponentType (){
           return this.componentTypes.filter(element => element.id === this.state.componentType)[0]
        }


    render(){
        this.jsonInputEl!.value = JSON.stringify(this.state);
        const SelectedComponent = this.currentComponentType?.editorEntryPoint;

        return (
            <div style={{width: "100%", padding: "0 1rem 0 1rem"}}>
                <div className="p-fluid p-formgrid p-grid">
                    <div className="p-field p-col">
                        <label htmlFor="title">Title</label>
                        <InputText id="title" type="text" value={this.state.title} onChange={(e) => this.setState(prevState => ({...prevState, title: e.target.value}))}/>
                    </div>
                </div>

                <div className="p-fluid p-formgrid p-grid">
                    <div className="p-field p-col">
                        <label htmlFor="width">Width</label>
                        <InputNumber inputId="width"  min={2} max={12} showButtons value={this.state.width}  onValueChange={(e) => this.setState(prevState =>({...prevState, width: e.value}))}/>
                    </div>
                </div>

                <div className="p-fluid p-formgrid p-grid">
                    <div className="p-field p-col">
                        <label htmlFor="type">Component type</label>
                         <Dropdown value={this.state.componentType}
                                   options={this.componentTypes}
                                   filter={true}
                                   onChange={(e) => this.setState(prevState => ({...prevState, componentType:e.target.value, jsonConfig:"{}"}))}
                                   optionLabel="name"
                                   optionValue="id"
                                   placeholder="Select a component type"
                         />
                    </div>
                </div>

                <TabView activeIndex={0}>
                    {SelectedComponent && isJSON(this.state.jsonConfig) && (
                        <TabPanel header={"Editor"}>
                            <Suspense fallback={<ProgressSpinner/>}>
                                <SelectedComponent config={JSON.parse(this.state.jsonConfig as string)} onConfigChange={this.onJSONChange}/>
                            </Suspense>
                        </TabPanel>
                        )
                    }
                    <TabPanel header={"Edit RAW JSON"}>
                    <div className="p-fluid p-formgrid p-grid">
                        <div className="p-field p-col">
                            <Editor
                                height="400px"
                                defaultLanguage="json"
                                value={this.state.jsonConfig}
                                onChange={(e) => this.setState(prevState => ({...prevState, jsonConfig:e}))}
                                onValidate={
                                    markers => {
                                        markers[0] && easasAlert("JSON is NOT Valid", markers[0].message ,"error")
                                    }
                                }
                                theme="vs-dark"
                            />
                        </div>
                    </div>
                    </TabPanel>
                </TabView>
            </div>
        );
    }
}

export default DashboardComponentConfigurator;
